<app-spinner-service></app-spinner-service>

<app-toolbar-search (onSearch)="applyFilterGlobal($event)" placeholder="Pesquisar declarações...">
</app-toolbar-search>

<p-tabView [(activeIndex)]="activeTab" (onChange)="onTabChange($event)">
  <p-tabPanel header="Declarações Mensais">
    <p-table #dtMensal [value]="declaracoesFiscaisMensais"
      [globalFilterFields]="['obrigacao', 'mesAno']"
      [paginator]="true" [rows]="10" responsiveLayout="scroll"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      class="custom-table"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 20, 50]">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="obrigacao" style="width: 30%">
            Obrigação
            <p-sortIcon field="obrigacao"></p-sortIcon>
          </th>
          <th pSortableColumn="mesAno" style="width: 30%">
            Mês/Ano
            <p-sortIcon field="mesAno"></p-sortIcon>
          </th>
          <th style="width: 40%">Downloads</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-declaracao let-i="rowIndex">
        <tr>
          <td>
            <div class="obrigacao-content">
              <i class="pi pi-file-pdf obrigacao-icon"></i>
              <span class="obrigacao-text" [pTooltip]="declaracao.obrigacao" tooltipPosition="top">{{ declaracao.obrigacao }}</span>
            </div>
          </td>
          <td>
            <div class="mes-ano-content">
              <i class="pi pi-calendar mes-ano-icon"></i>
              <span class="mes-ano-text" [pTooltip]="declaracao.mesAno" tooltipPosition="top">{{ declaracao.mesAno }}</span>
            </div>
          </td>
          <td>
            <div class="downloads-content">
              <button pButton
                *ngIf="declaracao.isManual && declaracao.declaracaoTransmitida?.declaracao"
                label="Download"
                icon="pi pi-download"
                class="p-button-rounded p-button-success download-button"
                (click)="baixarPdf(declaracao.declaracaoTransmitida.declaracao, 'download', declaracao.declaracaoTransmitida?.idDeclaracao, declaracao.nomeArquivoPersonalizado)"
                pTooltip="Baixar Arquivo"
                tooltipPosition="top">
               </button>
              <button pButton
                *ngIf="!declaracao.isManual && declaracao.declaracaoTransmitida?.declaracao"
                label="Declaração"
                icon="pi pi-download"
                class="p-button-rounded p-button-success download-button"
                (click)="baixarPdf(declaracao.declaracaoTransmitida.declaracao, 'declaração', declaracao.declaracaoTransmitida?.idDeclaracao)"
                pTooltip="Baixar Declaração"
                tooltipPosition="top">
               </button>
               <button pButton
                 *ngIf="!declaracao.isManual && declaracao.declaracaoTransmitida?.recibo"
                 label="Recibo"
                 icon="pi pi-download"
                class="p-button-rounded p-button-info download-button"
                (click)="baixarPdf(declaracao.declaracaoTransmitida.recibo, 'recibo', declaracao.declaracaoTransmitida?.idDeclaracao)"
                pTooltip="Baixar Recibo"
                tooltipPosition="top">
               </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="empty-message">
            <div class="empty-content">
              <i class="pi pi-file-pdf" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
              <h3>Nenhuma declaração encontrada</h3>
              <p>Não há declarações fiscais disponíveis para download.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>

  <p-tabPanel header="Declarações Anuais">
    <p-table #dtAnual [value]="declaracoesFiscaisAnuais"
      [globalFilterFields]="['obrigacao', 'mesAno']"
      [paginator]="true" [rows]="10" responsiveLayout="scroll"
      currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
      class="custom-table"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="[5, 10, 20, 50]">

      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="obrigacao" style="width: 30%">
            Obrigação
            <p-sortIcon field="obrigacao"></p-sortIcon>
          </th>
          <th pSortableColumn="mesAno" style="width: 30%">
            Mês/Ano
            <p-sortIcon field="mesAno"></p-sortIcon>
          </th>
          <th style="width: 40%">Downloads</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-declaracao>
        <tr>
          <td>
            <div class="obrigacao-content">
              <i class="pi pi-file-pdf obrigacao-icon"></i>
              <span class="obrigacao-text" [pTooltip]="declaracao.obrigacao" tooltipPosition="top">{{ declaracao.obrigacao }}</span>
            </div>
          </td>
          <td>
            <div class="mes-ano-content">
              <i class="pi pi-calendar mes-ano-icon"></i>
              <span class="mes-ano-text" [pTooltip]="declaracao.mesAno" tooltipPosition="top">{{ declaracao.mesAno }}</span>
            </div>
          </td>
          <td>
            <div class="downloads-content">
              <button pButton
                *ngIf="declaracao.declaracaoTransmitida?.declaracao"
                label="Declaração"
                icon="pi pi-download"
                class="p-button-rounded p-button-success download-button"
                (click)="baixarPdf(declaracao.declaracaoTransmitida.declaracao, 'declaração', declaracao.declaracaoTransmitida?.idDeclaracao)"
                pTooltip="Baixar Declaração"
                tooltipPosition="top">
               </button>
               <button pButton
                 *ngIf="declaracao.declaracaoTransmitida?.recibo"
                 label="Recibo"
                 icon="pi pi-download"
                 class="p-button-rounded p-button-info download-button"
                 (click)="baixarPdf(declaracao.declaracaoTransmitida.recibo, 'recibo', declaracao.declaracaoTransmitida?.idDeclaracao)"
                 pTooltip="Baixar Recibo"
                 tooltipPosition="top">
               </button>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="empty-message">
            <div class="empty-content">
              <i class="pi pi-file-pdf" style="font-size: 3rem; color: #6c757d; margin-bottom: 1rem;"></i>
              <h3>Nenhuma declaração encontrada</h3>
              <p>Não há declarações fiscais anuais disponíveis para download.</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </p-tabPanel>
</p-tabView>
